import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import UserSelfieVerificationPhotosData from "./user-seflie-verification-photos-data";
import UserSelfieVerificationPhotosForm from "./user-selfie-verification-photos-form";

const UserSelfieVerificationPhotos = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName(
      "USER_SELFIE_VERIFICATION_PHOTOS",
      "USER_SELFIE_VERIFICATION_PHOTOS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("USER")}
        subTitle={i18n.get("SELFIE_VERIFICATION_PHOTOS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <UserSelfieVerificationPhotosForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <UserSelfieVerificationPhotosData />
    </ET3PageDiv>
  );
});

export default UserSelfieVerificationPhotos;
